import React from "react";
import type { FooterColProps } from "../types";

export default function FooterCol({ title, items }: FooterColProps) {
  return (
    <div>
      <h4 style={{ margin: "0 0 14px 0", fontSize: 14, fontWeight: 700, color: "#fff" }}>
        {title}
      </h4>
      <ul
        style={{
          margin: 0,
          padding: 0,
          listStyle: "none",
          display: "flex",
          flexDirection: "column",
          gap: 10,
        }}
      >
        {items.map((it, i) => (
          <li key={i}>
            <a
              href="#"
              style={{
                color: "rgba(255,255,255,0.78)",
                textDecoration: "none",
                fontSize: 14,
              }}
            >
              {it}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}